import { FC } from 'react';
import { styled } from 'styled-components';
import { $fontSize, $marginTop, $paddingX, $paddingY, phoneSize } from '@/assets/styles/mediaSize';
import Image from '@/components/MediaComp/Image';
import useMessageStore, { IMessage } from '@/store/messageStore';

enum EAnswerType {
  text = 0,
  image = 1,
  link = 2,
}

interface IAnswer {
  uniqueId: string;
  type: EAnswerType;
  content: string;
  contents: { content: string; url: string }[];
}

interface IRobotSortAnswerProps {
  msgItem: IMessage;
}

const RobotSortAnswerWrap = styled.div`
  background-color: #fff;
  ${$paddingX('24rem', '12rem')}
  ${$paddingY('24rem', '12rem')}
  ${$fontSize('24rem', '14rem')}

  border-radius: 0 24rem 24rem 24rem;
  @media (min-width: ${phoneSize}) {
    border-radius: 0 12rem 12rem 12rem;
  }

  max-width: 540rem;
  word-break: break-all;
  overflow-x: auto;

  > div,
  > img,
  > a {
    &:not(:first-child) {
      margin-top: 16rem;
    }
  }
`;

const RobotSortAnswer: FC<IRobotSortAnswerProps> = (props) => {
  const messageStore = useMessageStore();

  const getMediaInxById = (uniqueId: string) => {
    const mediaMsgList = messageStore.getMediaMsgList();
    return mediaMsgList.findIndex((messageItem) => messageItem.uniqueId === uniqueId);
  };

  const answer = useMemo<IAnswer[]>(() => {
    let res: any[] = [];
    try {
      const temp: any[] = JSON.parse(props.msgItem.msgBody);
      res = temp.map((it: any, inx: number) => {
        if (it.type === EAnswerType.link) {
          let links;
          try {
            const tt = it.contents?.replace?.(/\n/g, '<br>');
            links = JSON.parse(tt);
          } catch (error) {
            links = [];
          }

          return {
            type: it.type,
            uniqueId: props.msgItem.uniqueId + '_' + inx,
            contents: links,
          };
        }

        return {
          type: it.type,
          uniqueId: props.msgItem.uniqueId + '_' + inx,
          content: it.content?.replace?.(/\n/g, '<br>'),
        };
      });
    } catch (error) {}
    return res;
  }, [props.msgItem]);

  return (
    <RobotSortAnswerWrap>
      {answer.map((item, inx) => {
        if (item.type === EAnswerType.image) {
          return (
            <Image
              onClick={() => {
                const inx = getMediaInxById(item.uniqueId);
                messageStore.setActivePreviewMediaInx(inx);
                messageStore.setShowPreviewMedia(true);
                if (window.parent) {
                  window.parent.postMessage({
                    type: 'preview',
                    visible: true
                  }, '*')
                }
              }}
              className="w-full rounded-16"
              key={inx}
              src={item.content}
            />
          );
        }
        if (item.type === EAnswerType.link) {
          return item.contents.map((it, i) => {
            if (it.url) {
              return (
                <a key={`${inx}_${i}`} className="text-#0054FC inline-block" onClick={() => window.open(it.url)}>
                  {it.content}
                </a>
              );
            }
            return <span key={`${inx}_${i}`}>{it.content}</span>;
          });
        }
        return (
          <div
            key={inx}
            dangerouslySetInnerHTML={{
              __html: item.content,
            }}
          ></div>
        );
      })}
    </RobotSortAnswerWrap>
  );
};

export default RobotSortAnswer;
